import {PIXI} from '@colonist/pixi'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {UIGameChatView} from './UIGameChatView'
import {UIGameLogView} from './UIGameLogView'
import {UIReplayView} from '../../ui_replay/elements/UIReplayView'
import {UIReplayController} from '../../ui_replay/UIReplayController'
import {UIGameManager} from '../UIGameManager'

export abstract class UIGameFeedView {
    protected readonly uiGameManager: UIGameManager
    gameChat: UIGameChatView
    gameLog: UIGameLogView
    replayView?: UIReplayView

    isMobile: boolean
    isTablet: boolean
    isChatEnabled: boolean

    protected readonly INPUT_ELEMENT_HEIGHT: number = 32
    protected readonly GAME_BLOCK_PADDING: number = 20

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.isMobile = UIUtilsEjsVariables.isUserOnMobile
        this.isTablet = PIXI.isMobile.tablet
        this.setChatVisibility()
        this.gameLog = new UIGameLogView()
        this.gameChat = new UIGameChatView(this.isChatEnabled)
        this.setGameFeedSize(1, 1)
    }

    setChatVisibility() {
        this.isChatEnabled = true
    }

    resizeChatBox(newAppW: number, newAppH: number) {
        const canvas = this.uiGameManager.canvasController
        const wRatioChanged = newAppW / canvas.appW
        const hRatioChanged = newAppH / canvas.appH
        this.setGameFeedSize(wRatioChanged, hRatioChanged)
    }

    buildReplayView(replayController: UIReplayController, isPortrait: boolean = false) {
        const useMinimalReplayControls = this.isMobile
        this.replayView = new UIReplayView(replayController, useMinimalReplayControls, isPortrait)

        const appW = parseFloat(this.uiGameManager.canvasController.app.view.style.width)
        const appH = parseFloat(this.uiGameManager.canvasController.app.view.style.height)
        this.resizeChatBox(appW, appH)
    }

    private setGameFeedSize(wRatio: number, hRatio: number) {
        const canvas = this.uiGameManager.canvasController
        const canvasX = canvas.responsiveController.getCanvasX()
        const canvasY = canvas.responsiveController.getCanvasY()
        const w = wRatio * canvas.chatWidth
        const h = hRatio * (canvas.appH - canvas.itemSize * 5.5)
        this.setSize(w, h)
        this.setPosition(canvasX, canvasY)
    }

    protected abstract setSize(w: number, h: number)
    protected abstract setPosition(canvasX: number, canvasY: number)
}
